<template lang="pug">
  .event-row
    .event-row__container
      .event-row__label-block
        p.event-row__label Event Type
        p.event-row__label-code LegalEntityEventType
      .event-row__value-block
        p.event-row__value-status(:class="getStatus")  {{item.type}}
    .event-row__container
      .event-row__label-block
        p.event-row__label Effective Date
        p.event-row__label-code LegalEntityEventEffectiveDate
      .event-row__value-block
        p.event-row__value {{formattedDate(item.effectiveDate)}}
    .event-row__container
      .event-row__label-block
        p.event-row__label Recorded Date
        p.event-row__label-code LegalEntityEventRecordedDate
      .event-row__value-block
        p.event-row__value {{formattedDate(item.recordedDate) }}
    .event-row__container
      .event-row__label-block
        p.event-row__label Validation
        p.event-row__label-code {{getValidationHeading}}
      .event-row__value-block
        p.event-row__value {{getValidationData}}
    .event-row__container(v-if="getFields")
      .event-row__label-block
        p.event-row__label Affected Fields
        p.event-row__label-code Affected Fields
      .event-row__fields-block
        .event-row__fields
          p.event-row__field(class='event-row__field-label') Field
          p.event-row__field(class='event-row__field-label') Value
        .event-row__fields(
          v-for='{value, xpath, fieldName} of getFields'
        )
          lei-popover(:text="xpath" placement="top").event-row__field
            p {{fieldName}}
          p.event-row__field {{value}}
</template>

<script>

import LeiPopover from '@/components/lei-components/LeiPopover'
import { timeFormat, } from '@/store/helpers.js'


export default {
  name: 'RecordModificationsRow',
  components: {
    LeiPopover,
  },
  props: {
    item: {
      type: [ Object, Array, ],
      required: true,
    },
  },

  computed: {
    getStatus () {
      if (this.item.status === 'COMPLETED') return { 'event-row__value-completed': true, }
      if (this.item.status === 'IN_PROGRESS') return { 'event-row__value-progress': true, }
      if (this.item.status === 'WITHDRAWN_CANCELLED') return { 'event-row__value-withdrawn': true, }
      return {}
    },
    getValidationData () {
      if (this.item.validationDocuments && this.item.validationReference){
        return `${this.item.validationDocuments & this.item.validationReference}`
      }
      return this.item.validationDocuments || this.item.validationReference || ''
    },
    getValidationHeading () {
      if (this.item.validationDocuments && this.item.validationReference){
        return 'Validation Documents & Validation Reference'
      }
      if (this.item.validationDocuments) return 'Validation Documents'
      if (this.item.validationReference) return 'Validation Reference'
      return ''
    },

    getFields () {
      if (!this.item.affectedFields) return false
      return this.item.affectedFields.map((field) => {
        return {
          ...field,
          fieldName: field.xpath.match(/([^/]+:)?[^:]+$/gm)[0].split('/').join(' /'),
          xpath: field.xpath.split('/').join(' /'),
        }})
    },
  },

  methods: {
    formattedDate (date) {
      return timeFormat(date)
    },
  },
}
</script>

<style lang="stylus" scoped>
   @import "../../../assets/styles/variables.styl"
   .event-row
    padding-top 25px
    width: 100%
    padding-left 20%


    &__container
      width 100%
      display flex
      flex-wrap wrap

    &__label-block
      width: 250px
      background-color $default-color-light-2
      text-align right
      padding 16px
      margin-right 10px
      margin-bottom 3px

    &__label
      font-weight 700
      margin-bottom 5px
      color $default-color
      &-code
        color $default-color
        line-height 1.5
        font-size: 0.8em;
        overflow-wrap: break-word;

    &__value-block
      width calc(100% - 260px)
      background-color $default-color-light-2
      flex-grow 1
      padding 16px
      margin-bottom 3px
    &__value
      color $default-color-bold-1
      &-status
        position relative
        padding-left 25px
        color $default-color-bold-1
        &::before
          content ''
          position absolute
          top 0
          left 0
          display inline-block
          width 15px
          height 15px
          border-radius 7.5px
      &-completed
        &::before
          background-color $success-color
      &-progress
        &::before
          background-color $warning-color
      &-withdrawn
        &::before
          background-color $danger-color
    &__fields-block
      width calc(100% - 260px)
      flex-grow 1

    &__fields
      display flex
      margin-bottom 3px

    &__field
      background-color $default-color-light-2
      padding 16px
      width 50%
      color $default-color-bold-1
      &:first-child
        margin-right 3px
      &-label
        font-weight 700
        color $default-color

    @media screen and (max-width: $laptop)
     &__label-block
      width 200px
     &__label-code
      word-break break-word
     &__field
      word-break break-word

  @media (max-width: $tablet)
    .event-row
      padding 20px 0 0

      &__label
        font-weight 600
        color $default-color-middle
      &__container
        border-bottom 1px solid $default-color-light-1
        padding: 5px 10px;

      &__label-block
        width 100%
        text-align left
        margin-right 0
        background-color $white-color
        padding: 5px 10px;
      &__value-block
        padding: 5px 10px;
        background-color $white-color
        width 100%
      &__fields-block
        width 100%
      &__field
        padding: 5px 10px;
        background-color $white-color
        &-label
          color $default-color-middle
          font-weight 600

      &__label-code
        display none



</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordEventsRow.vue